import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CheckList icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CheckList } from '@sravni/design-system-icons'
 *
 * <CheckList />
 * ```
 */
var CheckList = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CheckList", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.673 4.425h7.996M9.673 10.023h7.996M9.673 15.62h7.996M5.675 6.024H4.076a.8.8 0 0 1-.8-.8V3.625a.8.8 0 0 1 .8-.8h1.6a.8.8 0 0 1 .799.8v1.6a.8.8 0 0 1-.8.799ZM5.675 11.622H4.076a.8.8 0 0 1-.8-.8v-1.6a.8.8 0 0 1 .8-.799h1.6a.8.8 0 0 1 .799.8v1.6a.8.8 0 0 1-.8.799ZM5.675 17.218H4.076a.8.8 0 0 1-.8-.8V14.82a.8.8 0 0 1 .8-.8h1.6a.8.8 0 0 1 .799.8v1.599a.8.8 0 0 1-.8.8Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CheckList };
//# sourceMappingURL=CheckList.js.map
